import { Component } from '@angular/core';
import { LoaderComponent } from '@sb-tools/typescript/components/loader/loader.component';

@Component({
    selector: 'app-facebook-authentication',
    templateUrl: './facebook-authentication.component.html',
    styleUrls: ['./facebook-authentication.component.scss'],
    imports: [LoaderComponent],
})
export class FacebookAuthenticationComponent {}
